import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
const locations = [{
  name: "Aguascalientes",
  path: "https://wa.me/526149800517"
}, {
  name: "Chihuahua",
  path: "https://wa.me/526149800517"
}, {
  name: "Durango",
  path: "https://wa.me/526149800517"
}, {
  name: "Guanajuato",
  path: "https://wa.me/526149800517"
}, {
  name: "Sinaloa",
  path: "https://wa.me/526149800517"
}, {
  name: "Sonora",
  path: "https://wa.me/526149800517"
}];
export default function IndustriesServed() {
  return <section id="industries-served" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-default font-medium text-center text-foreground mb-12 md:mb-20">
          ¿Dónde estamos?
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center max-w-5xl mx-auto">
          {}
          <div className="relative w-full flex justify-center lg:justify-end">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/map_locations_mexico.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/map_locations_mexico.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/map_locations_mexico.png-wvc-sizes" alt="Mapa de ubicaciones en México" className="w-full max-w-[450px] h-auto object-contain" loading="lazy" src="https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-1.33.03-p.m.png" />
          </div>

          {}
          <div className="flex flex-col w-full max-w-md mx-auto lg:mx-0">
            {locations.map((location, i) => <Link key={i} to={location.path} data-index={i} target={location.path.startsWith("https://wa.me/") ? "_blank" : undefined} className="flex items-center py-5 border-b border-border/60 last:border-0 group hover:bg-accent/30 transition-colors px-4 -mx-4 rounded-md">
                <ArrowRight className="w-6 h-6 mr-6 text-foreground/80 group-hover:text-primary transition-colors shrink-0" />
                <span className="text-xl font-default text-foreground group-hover:text-primary transition-colors">
                  {location.name}
                </span>
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}